import { http } from "../http-common";

const fetchCountries = () => {
    return http.get('/countries');
};

const getCropYears = (config) => {
    return http.get(`/cropYears`, config);
};

const getCropStage = (config = {}) => {
    return http.get(`/cropStages`, config);
};

const getModule = (config = {}, cropStageIds = []) => {
    const query = cropStageIds.map(id => `cropStageId=${id}`).join('&') + '&level=1';
    return http.get(`/module/dropdown?${query}`, config);
 };

 const getSubModule = (config = {}, moduleIds = []) => {
    const query = moduleIds.map(id => `moduleId=${id}`).join('&') + '&level=2';
    return http.get(`/module/dropdown?${query}`, config);
 };

 const getTranslationData = (params = {}, config = {}) => {
    return http.post('/pending-translations', params, config);
};

const CheckPendingTranslationService = {
    fetchCountries,
    getCropYears,
    getCropStage,
    getModule,
    getSubModule,
    getTranslationData
};

export default CheckPendingTranslationService;